// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PlanInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PlanInput — body for POST /subscriptions/plans/create
 * and PUT /subscriptions/plans/{id}.
 *
 * All fields required (create context). For updates the controller
 * passes only the fields provided; validation runs against the full set.
 *
 * stripe_price_id is optional (nullable). When provided it must match the
 * ^price_ prefix (basic Stripe Price ID format guard). null/absent/empty
 * string are all valid (the field may be mapped later via the plan form).
 * stripe_price_id maps to provider_price_ref on the price row (not the plan row).
 *
 * currency is optional (nullable). When null/absent, defaults to 'BRL'.
 * When present, must be an uppercase ISO 4217 code from the allowed set:
 * BRL, USD, CLP.
 */
import { registerContract } from './validate'

export interface Subscriptions_PlanInput {
name: string
cycle: string
monthly_credit_grant: number
active: number
price_cents?: number
stripe_price_id?: string
currency?: string
}

registerContract('Subscriptions_PlanInput', {
  name:                 { type: 'string',  required: true },
  cycle:                { type: 'string',  required: true },
  monthly_credit_grant: { type: 'number',  required: true },
  active:               { type: 'number',  required: true },
  price_cents:          { type: 'number',  required: false },
  stripe_price_id:      { type: 'string',  required: false },
  currency:             { type: 'string',  required: false },
})
